import React from "react";

function FiltersSidebar() {
  return (
    <div style={styles.sidebar}>

      <div style={styles.label}>
        OEM DIAGRAMS
      </div>

      <div style={styles.card}>

        <div style={styles.badge}>
          COMING SOON
        </div>

        <div style={styles.title}>
          Interactive OEM
          <br />
          Parts Diagrams
        </div>

        <div style={styles.text}>
          Browse full exploded OEM schematics,
          locate exact components instantly,
          and navigate every system visually.
        </div>

        <div style={styles.line}></div>

        <div style={styles.footer}>
          ELEVEN VERIFIED
        </div>

      </div>

    </div>
  );
}

export default FiltersSidebar;

const styles = {

  sidebar: {
    width: 240,

    height: "fit-content",

    alignSelf: "start",

    fontFamily:
      "-apple-system, BlinkMacSystemFont, system-ui",
  },

  label: {
    fontSize: 11,
    fontWeight: 700,

    letterSpacing: "1.8px",

    color: "#8E8E93",

    marginBottom: 14,

    paddingLeft: 4,
  },

  card: {
    padding: 24,

    borderRadius: 28,

    background:
      "rgba(255,255,255,0.72)",

    backdropFilter:
      "blur(20px)",

    WebkitBackdropFilter:
      "blur(20px)",

    border:
      "1px solid rgba(255,255,255,0.95)",

    boxShadow:
      "0 20px 45px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.95)",
  },

  badge: {
    fontSize: 10,

    fontWeight: 700,

    letterSpacing: "1.8px",

    color: "#8E8E93",

    marginBottom: 18,
  },

  title: {
    fontSize: 28,

    lineHeight: "32px",

    fontWeight: 600,

    letterSpacing: "-1.2px",

    color: "#111111",

    marginBottom: 18,
  },

  text: {
    fontSize: 13,

    lineHeight: "27px",

    fontWeight: 600,

    letterSpacing: "0.3px",

    textTransform: "uppercase",

    color: "#8E8E93",
  },

  line: {
    height: 1,

    background:
      "rgba(0,0,0,0.06)",

    marginTop: 22,
    marginBottom: 18,
  },

  footer: {
    fontSize: 11,

    fontWeight: 700,

    letterSpacing: "2px",

    color: "#8E8E93",
  },

};